export const firebaseConfig = {
    apiKey: "AIzaSyB6OZE25YTSdQiTWKShjWZfWwkg2lTfzGc",
    authDomain: "talvar-195de.firebaseapp.com",
    projectId: "talvar-195de",
    storageBucket: "talvar-195de.firebasestorage.app",
    messagingSenderId: "404201273039",
    appId: "1:404201273039:web:2e6ff8d04978cd5d6969ba",
    measurementId: "G-C6NFTKRHYB"
};

export const googleMapsApiKey = "AIzaSyBQkGFtrWObfps93gXs1WZOIgZScr1_k0I";